<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="pt01">
<div class="partHead" id="ph01">
<h2 class="partTitle" style="text-indent: 25%;"><span class="bold"><em class="italic">Monday</em></span></h2>
<p class="centerImage2"><img alt="image" class="epubimage" src="Images/pt.jpg"/></p></div>
<div class="partBody">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429938327_pt01.vue?e46ff1a6